import { useMemo } from 'react';
import { IProjectSpaceTypeCategory } from 'spw-redux/modules/projects/types';
import { camelize } from 'spw-shared/utils';

export const useSpaceTypeCategories = (
  spaceTypeCategories: IProjectSpaceTypeCategory[]
): {
  individualWorkspacesCategory?: IProjectSpaceTypeCategory;
  meetingSpacesCategory?: IProjectSpaceTypeCategory;
  amenitySpacesCategory?: IProjectSpaceTypeCategory;
  supportSpacesCategory?: IProjectSpaceTypeCategory;
} => {
  return useMemo(
    () =>
      spaceTypeCategories.reduce(
        (acc, category) => ({
          ...acc,
          [`${camelize(
            category.defaultSpaceTypeCategory.category
          )}Category`]: category,
        }),
        {}
      ),
    [spaceTypeCategories]
  );
};
